export const PROMPT_PRESETS = [
  {
    id: "catchier",
    label: "キャッチーに書き直して",
    text: "このスライドのタイトルと本文を、読む人の心を掴むキャッチーな表現に書き直してください。数字や具体例を織り交ぜて印象に残る言い回しに。",
  },
  {
    id: "mentor-critique",
    label: "メンターの指摘を反映",
    text: "このスライドをベテランのコンサルやデザインメンターから『もっとこうしたほうがいい』と言われたら、という視点で磨き上げてください。情報の階層、文言、数値の見せ方を整え、ひと目で言いたいことが伝わる形にしてください。",
  },
  {
    id: "design-elevate",
    label: "デザインを引き上げる",
    text: "スライド全体の視線の流れとデザインの完成度を上げてください。フォントサイズ・配置・色の使い方を調整し、ひと目で重要な情報が飛び込んでくるバランスに整えてください。",
  },
  {
    id: "one-message",
    label: "1枚1メッセージに集約",
    text: "このスライドの『一番伝えたい一言』を特定し、それを主役に据えて再構成してください。余計な要素は削り、補助情報は脇役として控えめに配置してください。",
  },
  {
    id: "plain-ja",
    label: "専門用語をやさしく",
    text: "専門用語やカタカナビジネス用語を、中学生にも伝わるやさしい日本語に言い換えてください。情報量は保ったまま、誰でも読めるように。",
  },
  {
    id: "story-flow",
    label: "数字でストーリーを作る",
    text: "このスライドの情報を『問題 → 根拠（数字） → だから何』というストーリーの流れに整えてください。データがある場合は、数字が主役になるように配置・強調してください。",
  },
] as const;

export const DEFAULT_PROMPT = PROMPT_PRESETS[1].text; // mentor-critique as default
